import { WorkOrderBase } from './base-classes/work-order-base'

// Let's create a new instance of the base, to get separate filter for each work order view
// Imported modules are singletons, so we can't just import the same base modules because filter values will be overwritten
var workOrderBase = new WorkOrderBase()

workOrderBase.state.all.defaultFilter = {
  projectCode: this.projectCode,
  status: null,
  statuses: [],
  orderByColumn: 'verificationDate',
  orderByDescending: false,
  workOrderOwnerUserId: this.workOrderOwnerUserId
}

export const workOrdersPerProject = {
  namespaced: true,
  state: workOrderBase.state,
  actions: workOrderBase.actions(),
  mutations: workOrderBase.mutations(),
  getters: workOrderBase.getters()
}



// WEBPACK FOOTER //
// ./src/store/work-order-per-project.module.js